<template>
  <div :class="[{'smart-input_one-row': oneRow}, sizeClass]" class="smart-input">
    <div v-if="caption" class="smart-input__name">
      {{ caption }}
    </div>
    <div class="smart-input__wrapper">
      <template v-if="inputType === 'area'">
        <!--
        Срабатывает при вводе значения.
        @event input
        -->
        <textarea
          ref="elementForFocus"
          v-bind="$attrs"
          :disabled="disabled"
          :placeholder="placeholder"
          :value="value"
          class="smart-input__field smart-input__field_textarea"
          @input="$emit('input', $event.target.value || defaultIfEmpty)"
          @keyup.enter.stop
        />
      </template>
      <template v-else>
        <!--
        Срабатывает при вводе значения.
        @event input
        -->
        <input
          ref="elementForFocus"
          v-bind="$attrs"
          :disabled="disabled"
          :placeholder="placeholder"
          :type="inputType"
          :value="value"
          class="smart-input__field"
          @input="$emit('input', $event.target.value || defaultIfEmpty)"
        >
      </template>
      <!-- @slot Слот кнопки справа от поля ввода. -->
      <slot />
    </div>
    <div v-if="error" class="smart-input__error-message">
      {{ error }}
    </div>
  </div>
</template>

<script>
/**
 * Компонент для поля ввода текста (однострочного или многострочного) с возможностью отображения ошибок.
 * Можно передать слот `button` который будет расцениваться как дополнительная кнопка к простому полю ввода.
 *
 * Для многострочного поля ввода перехватывается нажатие по Enter и не распространяется дальше,
 * чтобы не ломать перевод на новую строку.
 *
 * todo обработка и преобразование Object - в основном для json
 */
export default {
  props: {
    /**
     * Значение, которое надо передавать через v-model.
     */
    value: {
      type: [String, Number, Object],
      default: null,
    },
    /**
     * Заголовок поля.
     */
    caption: {
      type: String,
      default: "",
    },
    /**
     * Содержимое для placeholder в input-элемент.
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * Вариант размера компонента.
     *
     * @values s, m, l.
     */
    size: {
      type: String,
      default: "m",
    },
    /**
     * Текст ошибки для поля.
     */
    error: {
      type: String,
      default: "",
    },
    /**
     * Опция установки фокуса в поле при его загрузке.
     *
     * Нет смысла передавать эту опцию одновременно в разных элементах на одном компоненте - тогда фокус будет на последнем по порядку.
     * Достаточно одного фокуса а остальные лучше убирать во избежание неоднозначностей.
     */
    makeFocus: {
      type: Boolean,
      default: false,
    },
    /**
     * Опция для отключения возможности ввода в поле.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Указывается конкретное значение, которое будет возвращено через `@input`, при условии если содержимое было стерто.
     */
    defaultIfEmpty: {
      type: [String, Number],
      default: null,
    },
    /**
     * Флаг для размещения подписи и поля ввода на одной строке.
     */
    oneRow: {
      type: Boolean,
      default: false,
    },
    /**
     * Опция для указания типа поля ввода.
     *
     * Если нужен многострочный ввод - указывается 'area', во всех остальных случаях будет однострочное поле,
     * а содержимое типа будет вставлено в тип input. По умолчанию это простой однострочный текст.
     *
     * @values text, area, number
     */
    inputType: {
      type: String,
      default: "text",
    },
  },
  /**
   * Фокус на поле ввода, если нужно.
   */
  mounted() {
    if (this.makeFocus) {
      this.$refs.elementForFocus.focus();
    }
  },
  computed: {
    /**
     * Вернуть класс, применяемый для размера компонента.
     *
     * @return {String}
     */
    sizeClass() {
      const sizeClasses = {
        "l": "smart-input_large",
        "m": "smart-input_medium",
        "s": "smart-input_small",
      };
      return _.get(sizeClasses, this.size, "smart-input_medium");
    },
  },
};
</script>

<style lang="scss">
@use "./scss/style.scss";
</style>
